module.exports = __webpack_public_path__ + "static/media/logo-synapse40x38.0af839e7.svg";